/**
 * Модальные окна
 */

export class Modal {

    /**
     * Инициализация модальных окон
     *
     * @param {string} button - data атрибут кнопки в занчении которого будет указано имя модалки
     * @param {string} modal  - data атрибут модалки в занчении которого будет указано ее имя
     * @param {string} close  - data атрибут элементов закрыитя модалки
     * @return void
     */

    init(button, modal, close) {

        if (!button || !modal || !close) {
            return false;
        }

        // Находим кнопки по атрибуту
        let modalOpen = document.querySelectorAll(`[data-${button}]`);
        // На каждую кнопку вешаем обработчик клика
        modalOpen.forEach( function(item) {
            item.addEventListener('click', function(e) {
                e.preventDefault();

                // Получаем значение атрибута кнопки
                let name = item.dataset[button],
                    // Находим модалку с таким же значением атрибута как у кнопки
                    modalWindow = document.querySelector(`[data-${modal}="${name}"]`);

                // Убраем скролл страницы
                document.body.style.overflow = 'hidden';
                document.documentElement.style.overflow = 'hidden';

                // Показываем модалку
                modalWindow.classList.add('is-active');

                // Вешаем обрабочик клика на модалку
                modalWindow.addEventListener('click', function(event) {

                    // Если элемент имеет атрибут {close}
                    if (event.target.hasAttribute(`data-${close}`)) {

                        // Возвращаем скролл страницы
                        document.body.style.overflow = '';
                        document.documentElement.style.overflow = '';

                        // Скрываем модалку
                        modalWindow.classList.remove('is-active');
                    }
                });
            });
        });
    }


    /**
     * Открытие модального окона
     *
     * @param {string} modal - data атрибут модалки в занчении которого будет указано ее имя
     * @param {string} name  - имя модалки
     * @param {string} close - data атрибут элементов закрыитя модалки
     * @return void
     */

    open(modal, name, close) {

        if (!modal || !name || !close) {
            return false;
        }

        let modalWindow = document.querySelector(`[data-${modal}="${name}"]`);

        // Убраем скролл страницы
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';

        // Показываем модалку
        modalWindow.classList.add('is-active');

        // Вешаем обрабочик клика на модалку
        modalWindow.addEventListener('click', function(event) {

            // Если элемент имеет атрибут {close}
            if (event.target.hasAttribute(`data-${close}`)) {

                // Возвращаем скролл страницы
                document.body.style.overflow = '';
                document.documentElement.style.overflow = '';

                // Скрываем модалку
                modalWindow.classList.remove('is-active');
            }
        });
    }
}